"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeAngle = exports.TWO_PI = void 0;
var core_api_1 = require("@ikegps/core-api");
/** 2 * Math.Pi */
exports.TWO_PI = Math.PI * 2;
/** Utility to help with working with angles */
var IkeAngle = /** @class */ (function () {
    function IkeAngle() {
    }
    /**
     * Case sensitive search for unit type
     * @see IkeAngle.toUnitAngle
     */
    IkeAngle.isUnitAngle = function (unit) {
        return unit === IkeAngle.RADIAN || unit === IkeAngle.DEGREE;
    };
    /** Case insensitive angle unit type search */
    IkeAngle.toUnitAngle = function (unit) {
        var searchUnit = unit.toLowerCase();
        if (IkeAngle.isUnitAngle(searchUnit)) {
            return searchUnit;
        }
        return null;
    };
    /**
     * Convert an angle to be between 0 and 2 * pi
     * @param value Angle (Radians)
     */
    IkeAngle.normalize = function (value) { return (value + exports.TWO_PI) % exports.TWO_PI; };
    /**
     * Rotate an angle by pi
     * @param value Angle (Radians)
     */
    IkeAngle.flip = function (value) { return (value + Math.PI) % exports.TWO_PI; };
    /**
     * Convert an angle from degrees to radians
     * @param degrees Angle (Degrees)
     */
    IkeAngle.toRadians = function (degrees) { return degrees * (Math.PI / 180); };
    /**
     * Convert an angle from radian to degrees
     * @param radians Angle (Radians)
     */
    IkeAngle.toDegrees = function (radians) { return radians * (180 / Math.PI); };
    IkeAngle.RADIAN = core_api_1.IkeUnitAngle.RADIAN;
    IkeAngle.DEGREE = core_api_1.IkeUnitAngle.DEGREE;
    return IkeAngle;
}());
exports.IkeAngle = IkeAngle;
//# sourceMappingURL=angle.js.map